import Admission from './admission'
import Appointment from './appointment'
import Area from './area'
import Auth from './auth'
import Calendar from './calendar'
import CalendarGoogle from './calendar_google'
import CalendarMicrosoft from './calendar_microsoft'
import Company from './company'
import Department from './department'
import Division from './division'
import Doctor from './doctor'
import Download from './download'
import Hospital from './hospital'
import Industry from './industry'
import Invitation from './invitation'
import Message from './message'
import Notice from './notice'
import Notification from './notification'
import OAuthGoogle from './o_auth_google'
import OAuthMicrosoft from './o_auth_microsoft'
import Read from './read'
import Report from './report'
import Room from './room'
import Schedule from './schedule'
import ScheduledTalk from './scheduled_talk'
import Talk from './talk'
import TalkTemplate from './talk_template'
import User from './user'
import { APIClient } from '@/infrastructure/network/Monitaro/APIClient'

export default class MonitaroGateway {
  apiClient: APIClient
  Admission: Admission
  Appointment: Appointment
  Area: Area
  Auth: Auth
  Calendar: Calendar
  CalendarGoogle: CalendarGoogle
  CalendarMicrosoft: CalendarMicrosoft
  Company: Company
  Department: Department
  Division: Division
  Doctor: Doctor
  Download: Download
  Hospital: Hospital
  Industry: Industry
  Invitation: Invitation
  Message: Message
  Notice: Notice
  Notification: Notification
  OAuthGoogle: OAuthGoogle
  OAuthMicrosoft: OAuthMicrosoft
  Read: Read
  Report: Report
  Room: Room
  Schedule: Schedule
  ScheduledTalk: ScheduledTalk
  Talk: Talk
  TalkTemplate: TalkTemplate
  User: User

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
    this.Admission = new Admission(apiClient)
    this.Appointment = new Appointment(apiClient)
    this.Area = new Area(apiClient)
    this.Auth = new Auth(apiClient)
    this.Calendar = new Calendar(apiClient)
    this.CalendarGoogle = new CalendarGoogle(apiClient)
    this.CalendarMicrosoft = new CalendarMicrosoft(apiClient)
    this.Company = new Company(apiClient)
    this.Department = new Department(apiClient)
    this.Division = new Division(apiClient)
    this.Doctor = new Doctor(apiClient)
    this.Download = new Download(apiClient)
    this.Hospital = new Hospital(apiClient)
    this.Industry = new Industry(apiClient)
    this.Invitation = new Invitation(apiClient)
    this.Message = new Message(apiClient)
    this.Notice = new Notice(apiClient)
    this.Notification = new Notification(apiClient)
    this.OAuthGoogle = new OAuthGoogle(apiClient)
    this.OAuthMicrosoft = new OAuthMicrosoft(apiClient)
    this.Read = new Read(apiClient)
    this.Report = new Report(apiClient)
    this.Room = new Room(apiClient)
    this.Schedule = new Schedule(apiClient)
    this.ScheduledTalk = new ScheduledTalk(apiClient)
    this.Talk = new Talk(apiClient)
    this.TalkTemplate = new TalkTemplate(apiClient)
    this.User = new User(apiClient)
  }
}
